import { render, staticRenderFns } from "./brand-manage.vue?vue&type=template&id=1e3d6d48&scoped=true&"
import script from "./brand-manage.vue?vue&type=script&lang=js&"
export * from "./brand-manage.vue?vue&type=script&lang=js&"
import style0 from "./brand-manage.vue?vue&type=style&index=0&lang=stylus&rel=stylesheet%2Fstylus&"
import style1 from "./brand-manage.vue?vue&type=style&index=1&id=1e3d6d48&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e3d6d48",
  null
  
)

export default component.exports